import { create } from "zustand";
import { persist } from "zustand/middleware";

export const THEMES = [
  { name: "Slate",   color: "#64748b" },
  { name: "Indigo",  color: "#6366f1" },
  { name: "Blue",    color: "#2563eb" },
  { name: "Violet",  color: "#7c3aed" },
  { name: "Rose",    color: "#e11d48" },
  { name: "Teal",    color: "#0d9488" },
  { name: "Orange",  color: "#ea580c" },
  { name: "Emerald", color: "#059669" },
];

export const useThemeStore = create(
  persist(
    (set) => ({
      themeColor: "#6366f1",
      isDark:     false,
      setThemeColor: (color) => set({ themeColor: color }),
      toggleDark:    ()      => set((s) => ({ isDark: !s.isDark })),
    }),
    { name: "vp-theme" }
  )
);
